import { UnitUtil } from 'kuaidong-lib'
import { IRewardTransImage, IRewardTransQuantity } from 'kuaidong-model'
import { IActivityStage } from '../models/config'

import ImgRewardTransBottleBg from '../images/img_reward_trans_bottle_bg@2x.png'

export type { IRewardTransImage, IRewardTransQuantity }

export interface IRewardTransBuildParams {
  rewardIcon: string
  stage?: IActivityStage | null
  transCount?: number
  bg?: string
  unit?: string
}

export const defaultRewardTransUnit = '扭蛋瓶'
export const defaultRewardTransBg = ImgRewardTransBottleBg

export function buildStageTransCount(_stage?: IActivityStage | null) {
  const item =
    _stage?.reward_items?.find((_rewardItem) => _rewardItem.trans_bottle_count != null) ||
    _stage?.reward_items?.find((_rewardItem) => _rewardItem.trans_bottle)

  return item?.trans_bottle_count
}

export function buildRewardTransQuantity(_count: number): IRewardTransQuantity {
  return {
    value: _count,
    positiveSign: 'x',
  }
}

export function buildRewardTransQuantityLabel(_quantity: IRewardTransQuantity) {
  const value = _quantity.value

  return `${UnitUtil.sign(typeof value === 'string' ? parseFloat(value) : value, {
    positive: _quantity.positiveSign || 'x',
  })}${value}`
}

export function buildRewardTransCount(_stage?: IActivityStage | null, _transCount?: number) {
  return buildStageTransCount(_stage) ?? _transCount ?? 0
}

export function buildRewardTransImage(_params: { rewardIcon: string; count: number; bg?: string }): IRewardTransImage {
  return {
    bg: _params.bg ?? defaultRewardTransBg,
    rewardIcon: _params.rewardIcon,
    quantity: buildRewardTransQuantity(_params.count),
  }
}

export function buildRewardTransItem(_params: IRewardTransBuildParams) {
  const unit = _params.unit ?? defaultRewardTransUnit
  const count = buildRewardTransCount(_params.stage, _params.transCount)
  const transReward = buildRewardTransImage({
    rewardIcon: _params.rewardIcon,
    count,
    bg: _params.bg,
  })

  return {
    name: `${count}${unit}`,
    transReward,
  }
}
